<template>
  <KycSdk
    v-if="isKYCWidgetOpen"
    :apiService="apiService"
    @on-success="onKYCSuccess"
    @on-close="closeKYCWidget" />
</template>

<script setup>
import { computed, watch } from "vue";
import { useRouter } from "vue-router";
import { Auth } from "@/api/auth";
import KycSdk from "@emcd-widgets/kyc/ui/kyc-sdk/index.vue";
import { useKycStore } from "@/stores/kyc";
import { useUserStore, KYC_STATUS } from "@/stores/user";
import { api } from "@/api";

const kycStore = useKycStore();
const userStore = useUserStore();
const router = useRouter();
const isKYCWidgetOpen = computed(() => kycStore.getIsKYCWidgetOpen());

const closeKYCWidget = () => {
  kycStore.setIsKYCModalOpen(false);
  kycStore.setIsKYCWidgetOpen(false);
  kycStore.setIsKYCButtonTempHidden(false);
  return api.user.getKycStatus();
};

// Sumsub reports "completed" before the backend gets its callback, so the fresh
// status is usually still pending — show it instead of silently closing
const onKYCSuccess = async () => {
  // The widget emits with a delay; skip if it was already closed (e.g. route change)
  if (!isKYCWidgetOpen.value) return;
  await closeKYCWidget();
  // Экран сам показывает результат KYC (WaitingKyc) — модалка статуса не нужна
  if (router.currentRoute.value.meta.showsKycStatus) return;
  const status = userStore.getKycStatus();
  if (status === KYC_STATUS.PENDING || status === KYC_STATUS.ERROR) {
    kycStore.setIsKYCPendingModalOpen(true);
  }
};

watch(router.currentRoute, () => {
  if (isKYCWidgetOpen.value) closeKYCWidget();
});

const apiService = {
  endpointApi: {
    // The widget expects axios-style rejections to read e.response.data.code and show its own error screen
    get: (url) =>
      Auth.getEndpointApi(url, { silentError: true }).then((res) => {
        if (!res?.ok) throw { response: { data: res } };
        return res.data;
      }),
  },
};
</script>

<style scoped>
:deep(.kyc-verification__wrapper) {
  width: calc(100dvw - 2px);
  height: 100dvh;
}

:deep(.kyc-verification__button) {
  height: 50px;
  width: 50px;
  max-width: 50px;
  max-height: 50px;
}
</style>
